import { route } from "quasar/wrappers";
import { useAuthStore } from "stores/auth";
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router";
import routes from "./routes";

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function ({ store /*, ssrContext*/ }) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === "history"
    ? createWebHistory
    : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(
      process.env.MODE === "ssr" ? void 0 : process.env.VUE_ROUTER_BASE
    ),
  });

  Router.beforeEach((to, from, next) => {
    const authStore = useAuthStore(store);
    const publicPages = ["/"];
    const authRequired = !publicPages.includes(to.path);
    const authorized = to.meta?.authorize?.includes(authStore.get?.rol);
    const mustChangePassword = authStore.get?.mustChangePassword;
    if (authRequired && !authorized) {
      if (!authorized) {
        window.dispatchEvent(new CustomEvent('show-access-denied'));
        next(from.fullPath);
      } else {
        authStore.set({});
        next({ name: "Login" });
      }
    } else if (!authRequired) {
      authStore.set({});
      next();
    } else if (mustChangePassword && authorized && to.name !== "Settings") {
      next({ name: "Settings" });
    } else {
      next();
    }
  });

  return Router;
});
